import api from "./client";
import { CreateRequestPayload, GuestRequest } from "../types";

export const createRequest = (data: CreateRequestPayload) => {
  return api.post<GuestRequest>("/requests", data);
};

export const getRequests = (weddingId: string) => {
  return api.get<GuestRequest[]>("/requests", { params: { weddingId } });
};

export const getMyRequest = (weddingId: string) => {
  return api.get<GuestRequest | null>("/requests/mine", { params: { weddingId } });
};

export const approveRequest = (id: string) => {
  return api.post(`/requests/${id}/approve`);
};

export const declineRequest = (id: string) => {
  return api.post(`/requests/${id}/decline`);
};
